// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__cSdAu","title":"Header_title__1SDtB","left":"Header_left__1NIxp","clinicName":"Header_clinicName__2pRZu"};